module.exports = __webpack_public_path__ + "static/img/Logo9_ThePeninsulaBangkok.3838bf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo9_ThePeninsulaBangkok.png
// module id = 322
// module chunks = 2